module.exports = __webpack_public_path__ + "img/rjc@2x.0578b2c.jpg";